import { ComponentsReducers } from "@insite/client-framework/Store/Components/ComponentsReducer";
import { DataReducers } from "@insite/client-framework/Store/Data/DataReducer";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import dataReducer from "@store/Framework/Store/Store/Data/DataReducer";
import pagesReducer, { PagesReducers } from "@store/Framework/Store/Store/Pages/PagesReducer";
import { combineReducers } from "redux";

const storeReducers = {
    pages: pagesReducer,
    data: dataReducer,
};

const storeReducer = combineReducers(storeReducers as any);
(reducers as any).store = combineReducers(storeReducers);

type Reducers = Omit<typeof storeReducers, "pages">;
export type StoreAction =
    | AnyAction
    | Parameters<Reducers[keyof Reducers]>[1]
    | Parameters<PagesReducers[keyof PagesReducers]>[1]
    | Parameters<ComponentsReducers[keyof ComponentsReducers]>[1]
    | Parameters<DataReducers[keyof DataReducers]>[1];

export type StoreActions = Parameters<DataReducers[keyof DataReducers]>[1] | AnyAction;

console.log("storeReducer");
export default storeReducer;
